export default "__VITE_ASSET__cCsbeTfE__"